'use client';

import { useEffect } from 'react';
import { installFrontendErrorReporter } from '@/lib/frontend-error-reporter';

export default function FrontendErrorMonitor() {
  useEffect(() => {
    installFrontendErrorReporter();
  }, []);
  return null;
}
